import { render } from "./container.vue?vue&type=template&id=1d613a8b"
import script from "./container.vue?vue&type=script&lang=js"
export * from "./container.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Shoma\\Documents\\Manabibako\\src\\basic-package30\\app\\Elearning\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Scripts/components/pages/contents/container.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1d613a8b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1d613a8b', __exports__)) {
    api.reload('1d613a8b', __exports__)
  }
  
  module.hot.accept("./container.vue?vue&type=template&id=1d613a8b", () => {
    api.rerender('1d613a8b', render)
  })

}


export default __exports__